import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Overlay } from '@angular/cdk/overlay';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { Location } from '@angular/common';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { TclcHistoryComponent } from '../tclc-history/tclc-history.component';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { TcDocumentUploadComponent } from '../tc-document-upload/tc-document-upload.component';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { ThirdPartyPayReceiptComponent } from '../third-party-pay-receipt/third-party-pay-receipt.component';

@Component({
  selector: 'app-tclc-approval',
  templateUrl: './tclc-approval.component.html',
  styleUrls: ['./tclc-approval.component.scss']
})

export class TclcApprovalComponent implements OnInit, AfterViewInit {
  Tclcdata: any;
  stepperForm: FormGroup;
  personalDetailsForm: FormGroup;
  ScrutinyForm: FormGroup;
  CertScrutinyForm: FormGroup;
  contactDetailsForm: FormGroup;
  reservationsDetailsForm: FormGroup;
  qualificationDetailsForm: FormGroup;
  additionalDetailsForm: FormGroup;
  photoSignDetailsForm: FormGroup;
  admissionDetailsForm: FormGroup;
  documentDetailsForm: FormGroup;
  marritalList: any;
  filteredmarritalstatusList: any;
  filteredBloodGroupList: any;
  bloodgroupList: any;
  filteredGenderList: any;
  genderList: any;
  isDivShow: boolean;
  isreadonly = true;
  dialogRef1: MatDialogRef<any>;
  CountryCodeList: any;
  filteredListCountryCode: any;
  StateCodeList: any;
  filteredListState: any;
  districtCodeList: any;
  filteredListDistrict: any;
  qualList: any;
  regionList: any;
  filteredRegionList: any;
  filteredDomicileList: any;
  domicileList: any;
  filteredNationalityList: any;
  nationalityList: any;
  filteredMinorityList: any;
  minorityList: any;
  categoryList: any[];
  filteredCategoryList: any[];
  religionList: any;
  filteredReligionList: any;
  specialAbledList: any;
  filteredspecialAbledList: any;
  orphanTypeList: any;
  filteredorphanTypeList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  userImage: any;
  signatureImage: any;
  proId: any;
  facultyList: any;
  filteredFacultyList: any;
  courseList: any;
  filteredCourseList: any;
  courseStreamList: any;
  filteredStreamList: any;
  examList: any;
  filteredExamList: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  ducumentList: any;
  ScrutinyLevel: 0;
  UserId: 0;
  ScrutinyId: 0;
  StudentId: 0;
  CoCode: 0;
  CgCode: 0;
  SessionId: 0;
  LoginName: any;
  FirstName: any;
  MiddleName: any;
  LastName: any;
  from: any;
  filteredstudyModeList: any;
  studyModeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  mothertoungList: any;
  filteredMotherToungList: any;
  BranchId = 0;
  subList: any;
  filteredSubList: any;
  PassYearList: any;
  filteredPassYearList: any;
  courseLevelList: any;
  courseQualList: any;
  filteredcourseList: any;
  boardUniList: any;
  filteredboardUniList: any;
  Subs = false;
  OptSub = false;
  Min: any;
  Max: any;
  SubjectName: any[] = [];
  ErrorMessage: string;
  optData: any;
  GroupData: any;
  SubError = false;
  selectedValues: any[] = [];
  Subjects: any[] = [];
  selectedCheckboxes: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  years: number[] = this.generateYears(1975, new Date().getFullYear());
  newSelectedValues = [];
  Sub: any[] = [];
  AllSub: any[] = [];
  selectedOptions: any = [];

  SubjectData = [];
  StateCodeListP: any;
  filteredListStateP: any;
  districtCodeListP: any;
  filteredListDistrictP: any;
  StuSubId = 0;
  SessionFilterList: any;
  sessionList: any;
  filteredtehasilPList: any;
  tehasilPList: any;
  tehasilCList: any[];
  filteredtehasilCList: any[];
  filteredListDistrictC: any;
  districtCodeListC: any;
  filteredListStateC: any;
  StateCodeListC: any;
  PCountryCodeList: any;
  filteredListPCountryCode: any;
  CfilteredListCountryCode: any;
  CCountryCodeList: any;
  SRList: any;
  filteredSR: any;
  dialogRef: MatDialogRef<any>;
  isformreadonly = true;
  examData: any;
  CertList: any;
  filteredCertList: any;
  CertScrId: any;
  DestClgTrue: any;
  AdmFeesPaid: boolean;
  FeesData: any;
  userPermission: any;
  StudentName: string;
  TranscriptData: any;
  TclcDoc: boolean;
  TclcDocData: any;
  Transcript: boolean;
  ScrutinyFormArray: any = {};
  FeesStatus: any;
  wesDesc: any;
  AdminUpload: any;
  ShowPersonal: boolean;
  ShowContact: boolean;
  ShowReservation: boolean;
  ShowQualify: boolean;
  ShowAddit: boolean;
  ShowPhoto: boolean;
  ShowAdmission: boolean;
  ShowDoc: boolean;
  RgNo: any;
  reptCourse: string;
  
  isLoadingPersonal = true;
  isLoadingContact = true;
  isLoadingReservation = true;
  isLoadingQualification = true;
  isLoadingAdditional = true;
  isLoadingPhotoSign = true;
  isLoadingAdmission = true;
  isLoadingDocument = true;
  isLoadingTclcDocs = true;
  isLoadingUploadedDocs = true;
  isLoadingTranscript = true;
  isLoadingCertStatus = true;
  isLoadingPage = true;
  
  // Payment details
  paymentDetails: any = null;
  showPaymentDetails = false;

  constructor(private dialog: MatDialog, private location: Location,
    private fb: FormBuilder,
    public router: Router,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe, private overlay: Overlay,
    private route: ActivatedRoute) { }
  // studentId = 1084
  // studentId = 22
  personalDetailsFormArray: any = {};
  contactDetailsFormArray: any = {};
  reservationsDetailsFormArray: any = {};
  qualificationDetailsFormArray: any = {};
  additionalDetailsFormArray: any = {};
  admissionDetailsFormArray: any = {};
  personalData: boolean = false;
  ContactData: boolean = false;
  ReservationData: boolean = false;
  AdditionalData: boolean = false;
  QualificationData: boolean = false;
  AdmissionData: boolean = false;
  DocumentData: boolean = false;
  PhotoSignData: boolean = false;
  ScrutinyData: boolean = false;
  DocUploaded: boolean = false;
  isOpen = true;
  showchat = false;
  showchattt = true
  readonly = true;
  hideStudentDetails = false;
  isStuCasteDisable = false
  isStuCasteCertDisable = false
  isStuCasteValCertDisable = false;
  isStuNonCrmValDtDisable = false;
  isStuOrphanTypeDisable = false;
  isStuSpecialAbledTypeDisable = false;
  isStuMinorityTypeDisable = false;
  isStuNonCrmCertDisable = false
  isStuMinorityType2Disable = false;
  isStuInHouseDisable = false;
  isStuMinorityDisable = false;
  currentdate: any;
  isStuNonCrmValDtDisable2 = false;
  disableMinority = true;
  resultNotDec = false;
  UpdateBtn = false;
  SaveDisabled = false;
  tclc: any = []
  feeType: 'TS' | 'ASC' | 'RET' | 'LANG' | 'ATTFE' | 'VOD' = 'TS';   
  ngOnInit(): void {
    let id = '';
    this.stepperForm = new FormGroup({
      personalDetailsForm: new FormControl(),
      CertScrutinyForm: new FormControl(),
      contactDetailsForm: new FormControl(),
      reservationsDetailsForm: new FormControl(),
      qualificationDetailsForm: new FormControl(),
      additionalDetailsForm: new FormControl(),
      photoSignDetailsForm: new FormControl(),
      admissionDetailsForm: new FormControl(),
      documentDetailsForm: new FormControl(),
      ScrutinyForm: new FormControl(),
    });
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));

    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state as any;
    let dataFromService = this.umsService.getTclcData();
    
    if (state && state.tclcData) {
      this.Tclcdata = state.tclcData;
    } else if (dataFromService && Object.keys(dataFromService).length > 0) {
      this.Tclcdata = dataFromService;
    } else {
      const storedData = sessionStorage.getItem('tclcData');
      if (storedData) {
        this.Tclcdata = JSON.parse(storedData);
      } else {
        this.Tclcdata = {};
      }
    }
    
    this.StuSubId = this.Tclcdata?.StuSubId ?? 0; 
    
    if (this.Tclcdata?.CertType === 'ASC') {
      this.feeType = 'ASC';
    } else if (this.Tclcdata?.CertType === 'RET') {
      this.feeType = 'RET';
    } else if (this.Tclcdata?.CertType === 'LANG') {
      this.feeType = 'LANG';
    } else if (this.Tclcdata?.CertType === 'ATTFE') {   
      this.feeType = 'ATTFE';
    } else if (this.Tclcdata?.CertType === 'VOD') {   
      this.feeType = 'VOD';
    } else {
      this.feeType = 'TS';
    }
    
    this.loadsettingspage(this.Tclcdata['CertType']);
  }

  initialize() {
    this.isLoadingPage = true;
    this.tclc = [];
    this.fetchCertStatus()
    this.tclc.push(this.Tclcdata)
    this.FeesStatus = this.tclc[0]['FeeStatus'];
    this.getTclcDocs(this.Tclcdata['StuId'])
    this.GetTranscript(this.Tclcdata['StuId']);
    this.prepopulationP()
    this.DestClgTrue = this.tclc[0]['CertType']
    this.StudentId = this.Tclcdata['StuId']
    this.checkLock();
    this.currentdate = new Date();
    if (this.from === 'report') {
      this.showchattt = false
      this.isformreadonly = true;
      this.UpdateBtn = true;
    } else {
      this.showchattt = true
      this.isformreadonly = false;
      this.UpdateBtn = false;
    }

    this.getScrData()
    Object.keys(this.ScrutinyFormArray).forEach((tabKey) => {
      const tabData = this.ScrutinyFormArray[tabKey];
      switch (tabKey) {
        case 'PersonalTab':
          // Handle PersonalTab
          if (tabData[0]?.FormVisible) {
            this.personalDetailsForm = new FormGroup({
              StuRgNo: new FormControl(this.StudentId),
              StuId: new FormControl(""),
            });
            this.prepopulationP();
          }
          break;
        case 'ContactTab':
          if (tabData[0]?.FormVisible) {
            this.contactDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuAddrId: new FormControl(""),
            });
            this.prepopulationC();
          }
          break;
        case 'ReservationTab':
          if (tabData[0]?.FormVisible) {
            this.reservationsDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuResId: new FormControl(''),
            });
            this.prepopulationR();
          }
          break;
        case 'AdditionalTab':
          if (tabData[0]?.FormVisible) {
            this.additionalDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuExtraId: new FormControl(),
            });
            this.prepopulationA();
          }
          break;
        case 'QualificationTab':
          if (tabData[0]?.FormVisible) {
            this.qualificationDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuQualId: new FormControl(),
            });
            this.prepopulationQ();
          }
          break;
        case 'PhotoSignTab':
          if (tabData[0]?.FormVisible) {
            this.photoSignDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
              StuRgNo: new FormControl(this.StudentId),
              StuPhoto: new FormControl(''),
              StuSignature: new FormControl(''),
            });
            this.prepopulationPS();
          }
          break;
        case 'AdmissionTab':
          if (tabData[0]?.FormVisible) {
            this.admissionDetailsForm = this.fb.group({
              StuId: new FormControl(this.StudentId),
            });
            this.prepopulationAD();
          }
          break;
        case 'DocumentTab':
          if (tabData[0]?.FormVisible) {
            this.documentDetailsForm = this.fb.group({
              "StuRemarkConfirm": new FormControl(''),
              "StuRemarkCheck": new FormControl(''),
              arrData: this.fb.array([]),
            });
            this.fetchDocument();
          }
          break;
        case 'ExamPassedTab':
          if (tabData[0]?.FormVisible) {
            this.ExamData()
          }
          break;
        case 'AdmissionFeeTab':
          if (tabData[0]?.FormVisible) {
            this.AdmFees()
          }
          break;
        default:
          break;
      }
    });
    this.CertScrutinyForm = new FormGroup({
      Comment: new FormControl(this.Tclcdata['Comment'] || ''),
      CertStatus: new FormControl(this.Tclcdata['CertStatus'] || ''),
    })
    this.UploadedDocs();
    
    if ((this.Tclcdata['CertStatus'] == 'APR' || this.Tclcdata['CertStatus'] == 'REJ' || this.Tclcdata['CertStatus'] == 'REC') && this.Tclcdata['CertType'] != 'ADMC') {
      this.SaveDisabled = true;
    }
    else if (this.Tclcdata['CertStatus'] == 'APPAP' && this.Tclcdata['CertType'] == 'ADMC') {
      this.SaveDisabled = true;
    }
    else if (this.Tclcdata['CertStatus'] == 'APR' && this.Tclcdata['CertType'] == 'TS') {
      this.SaveDisabled = true;
    }
    else {
      this.SaveDisabled = false;
    }

    if (this.Tclcdata['CertType'] === 'ASC' || this.Tclcdata['CertType'] === 'RET' || this.Tclcdata['CertType'] === 'LANG' || this.Tclcdata['CertType'] === 'ATTFE' || this.Tclcdata['CertType'] === 'VOD') {   
      this.hideStudentDetails = true;
    } else {
      this.hideStudentDetails = false;
    }
    
    if (this.shouldFetchPaymentDetails()) {
      this.fetchPaymentDetails();
    }
    
    setTimeout(() => {
      this.isLoadingPage = false;
    }, 500);
  }

  ngAfterViewInit(): void {}

  // ==================== PAYMENT METHODS ====================
  
  private get hasOrgId(): boolean {
    return this.Tclcdata && 
           this.Tclcdata.OrgId != null && 
           this.Tclcdata.OrgId !== 0 && 
           this.Tclcdata.OrgId !== '' && 
           this.Tclcdata.OrgId !== 'null';
  }

  shouldFetchPaymentDetails(): boolean {
    return this.hasOrgId && this.Tclcdata.FeeStatus === 'Y';
  }

  fetchPaymentDetails() {
    const tclcId = this.Tclcdata?.TclcId || 0;
    const certType = this.Tclcdata?.CertType || 'VOD';
    
    if (!tclcId || tclcId === 0) {
      this.paymentDetails = null;
      this.showPaymentDetails = false;
      return;
    }
    
    let sessionId = this.Tclcdata?.SnNo || 0;
    if (sessionId === 0) {
      const sessionData = JSON.parse(sessionStorage.getItem('session') || '{}');
      sessionId = sessionData?.SnNo || 0;
    }
    
    this.spinner.show();
    const payload = {
      CertType: certType,
      TclcId: tclcId,
      OrgId: this.Tclcdata?.OrgId || 0
    };

    this.umsService.SearchOrgFeeRept(payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.status && res.data && res.data.length > 0) {
          this.paymentDetails = res.data[0];
          this.showPaymentDetails = true;
        } else {
          this.paymentDetails = null;
          this.showPaymentDetails = false;
        }
      },
      error: () => {
        this.spinner.hide();
        this.paymentDetails = {
          ReceiptNo: 'ORG-' + this.Tclcdata?.TclcId,
          Amount: 0,
          Status: 'Pending',
          ApplicationModule: this.Tclcdata?.CertType || 'VOD',
          PaymentSource: 'Organization',
          TxnNumber: 'ORG-' + this.Tclcdata?.TclcId,
          OrgId: this.Tclcdata?.OrgId,
          FeeTemplateCode: this.Tclcdata?.CertType || 'VOD'
        };
        this.showPaymentDetails = true;
      }
    });
  }

  // ============ Receipt Methods ============
  
  Receipt(feeType: 'TS' | 'ASC' | 'RET' | 'LANG' | 'ATTFE' | 'VOD' = 'TS', StuSubId?) {   
    this.spinner.show();
    const payload = { FeeType: feeType };

    this.umsService.fetchFeeTempTclc(payload).subscribe({
      next: (res) => {
        if (res.status && res.data?.length) {
          this.openReceipt(res.data[0].TemplateCode, feeType);
        }
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  }

  private openReceipt(tempCode: string, feeType: string) {
    let data;
    
    if (this.hasOrgId) {
      const paymentData = this.paymentDetails || {};
      data = {
        StuId: this.StudentId,
        SnNo: this.Tclcdata['SnNo'] || 0,
        Session: this.Tclcdata['SnNo'] || 0,
        FeeType: feeType || this.Tclcdata['CertType'] || 'VOD',
        TclcId: this.Tclcdata['TclcId'],
        OrgId: this.Tclcdata['OrgId'],
        TemplateCode: paymentData.FeeTemplateCode || tempCode || this.Tclcdata['CertType'] || 'VOD',
        RgNo: this.Tclcdata['RgNo'] || this.Tclcdata['StuPRN'],
        StuSubId: this.StuSubId,
        College: this.Tclcdata['CgName'] || this.Tclcdata['College'],
        Course: this.Tclcdata['CoName'] || this.Tclcdata['Course'],
        StuName: this.Tclcdata['StuName'],
        ReceiptNo: paymentData.ReceiptNo || paymentData.PaymentResponseId || 'ORG-' + this.Tclcdata['TclcId'],
        PaymentResponseId: paymentData.PaymentResponseId,
        Amount: paymentData.Amount || 0,
        PaymentDate: paymentData.PaymentDate || new Date().toISOString(),
        PayModeTitle: paymentData.PayModeTitle || 'Organization',
        ApplicationModule: paymentData.ApplicationModule || feeType || 'VOD',
        PaymentSource: paymentData.PaymentSource || 'Organization',
        TxnNumber: paymentData.TxnNumber || 'ORG-' + this.Tclcdata['TclcId'],
        Status: paymentData.Status || 'Paid',
        Email: paymentData.Email || this.Tclcdata['Email'] || this.Tclcdata['EmailID'],
        Phone: paymentData.Phone || this.Tclcdata['MobileNo'] || this.Tclcdata['StuNumber'],
        RawResponse: paymentData.RawResponse,
        ResponseCode: paymentData.ResponseCode,
        ResponseMessage: paymentData.ResponseMessage,
        Mode: paymentData.Mode,
        ReceiptDate: paymentData.ReceiptDate || paymentData.PaymentDate,
        DeliveryOpt: this.Tclcdata['DeliveryOpt'] || 'Both'
      };
      
      this.dialog.open(ThirdPartyPayReceiptComponent, {
        width: '90vh',
        height: '80vh',
        data: data,
        disableClose: true
      });
      
    } else {
      if (tempCode == 'ASC' || tempCode == 'RET' || tempCode == 'LANG' || tempCode == 'ATTFE' || tempCode == 'VOD') {   
        data = {
          SnNo: this.Tclcdata['SnNo'],
          TemplateCode: tempCode,
          StuId: this.StudentId,
          FeeType: feeType,
          RgNo: this.Tclcdata['RgNo'],
          StuSubId: this.StuSubId
        };
      } else {
        data = {
          SnNo: this.Tclcdata['SnNo'],
          TemplateCode: tempCode,
          StuId: this.StudentId,
          FeeType: feeType,
          Course: this.TranscriptData[0]?.Course || this.Tclcdata['CoName'],
          College: this.TranscriptData[0]?.College || this.Tclcdata['CgName'],
          StuName: this.TranscriptData[0]?.StuName || this.Tclcdata['StuName'],
          RgNo: this.Tclcdata['RgNo']
        };
      }

      this.dialog.open(PaymentReceiptComponent, {
        width: '90vh',
        height: '80vh',
        data: data,
        disableClose: true
      });
    }
  }

  viewPaymentReceipt() {
    if (this.hasOrgId) {
      if (!this.paymentDetails) {
        this.modalPopupService.openPopup(AlertBoxComponent, {
          message: 'No payment details found for this application.',
          title: 'Information',
          icon: 'fas fa-info-circle'
        });
        return;
      }

      const paymentData = this.paymentDetails || {};
      const receiptData = {
        StuId: this.Tclcdata.StuId,
        SnNo: this.Tclcdata.SnNo || 0,
        Session: this.Tclcdata.SnNo || 0,
        FeeType: this.Tclcdata.CertType,
        TclcId: this.Tclcdata.TclcId,
        OrgId: this.Tclcdata.OrgId,
        TemplateCode: paymentData.FeeTemplateCode || this.Tclcdata.CertType,
        ReceiptNo: paymentData.ReceiptNo || paymentData.PaymentResponseId,
        PaymentResponseId: paymentData.PaymentResponseId,
        Amount: paymentData.Amount,
        PayModeTitle: paymentData.PayModeTitle,
        PaymentDate: paymentData.PaymentDate,
        ApplicationModule: paymentData.ApplicationModule,
        PaymentSource: paymentData.PaymentSource,
        TxnNumber: paymentData.TxnNumber,
        RgNo: this.Tclcdata.RgNo || this.Tclcdata.StuPRN,
        College: this.Tclcdata.CgName,
        Course: this.Tclcdata.CoName,
        StuName: this.Tclcdata.StuName,
        Email: paymentData.Email,
        Phone: paymentData.Phone,
        Status: paymentData.Status,
        RawResponse: paymentData.RawResponse,
        ResponseCode: paymentData.ResponseCode,
        ResponseMessage: paymentData.ResponseMessage,
        Mode: paymentData.Mode,
        ReceiptDate: paymentData.ReceiptDate || paymentData.PaymentDate,
        DeliveryOpt: this.Tclcdata.DeliveryOpt || 'Both'
      };

      this.dialog.open(ThirdPartyPayReceiptComponent, {
        width: '90vh',
        height: '80vh',
        data: receiptData,
        disableClose: true
      });

    } else {
      if (!this.paymentDetails) {
        const receiptData = {
          StuId: this.Tclcdata.StuId,
          SnNo: this.Tclcdata.SnNo,
          Session: this.Tclcdata.SnNo,
          FeeType: this.Tclcdata.CertType,
          TclcId: this.Tclcdata.TclcId,
          RgNo: this.Tclcdata.RgNo || this.Tclcdata.StuPRN,
          College: this.Tclcdata.CgName,
          Course: this.Tclcdata.CoName,
          StuName: this.Tclcdata.StuName
        };

        this.dialog.open(PaymentReceiptComponent, {
          width: '90vh',
          height: '80vh',
          data: receiptData,
          disableClose: true
        });
        return;
      }

      const receiptData = {
        StuId: this.Tclcdata.StuId,
        SnNo: this.Tclcdata.SnNo,
        Session: this.Tclcdata.SnNo,
        FeeType: this.Tclcdata.CertType,
        TclcId: this.Tclcdata.TclcId,
        TemplateCode: this.paymentDetails.FeeTemplateCode || this.Tclcdata.CertType,
        ReceiptNo: this.paymentDetails.ReceiptNo || this.paymentDetails.PaymentResponseId,
        PaymentResponseId: this.paymentDetails.PaymentResponseId,
        Amount: this.paymentDetails.Amount,
        PayModeTitle: this.paymentDetails.PayModeTitle,
        PaymentDate: this.paymentDetails.PaymentDate,
        RgNo: this.Tclcdata.RgNo || this.Tclcdata.StuPRN,
        College: this.Tclcdata.CgName,
        Course: this.Tclcdata.CoName,
        StuName: this.Tclcdata.StuName
      };

      this.dialog.open(PaymentReceiptComponent, {
        width: '90vh',
        height: '80vh',
        data: receiptData,
        disableClose: true
      });
    }
  }

  isOrganizationPayment(): boolean {
    return this.hasOrgId;
  }

  // ==================== PERSONAL DETAILS ====================
  personalDetails() {
    this.ageCalculate();
    this.fetchMarritalStatus();
    this.fetchBloodGroup();
    this.fetchGender();
    this.fetchMotherTounge();
  }

  contactDetails() {
    this.fetchCountry();
    this.fetchDistrict();
    this.fetchState();
    this.fetchNationality();
    this.fetchDomicile();
    this.fetchRegion();
    this.fetchCountryP();
    this.fetchCountryC()
  }

  reservationDetails() {
    this.fetchReligion();
    this.fetchSpAbled();
    this.fetchorphanType();
    this.fetchConstiCate();
    this.fetchSocialReservation();
  }

  admissionDetails() {
    this.getFacultyData();
    this.fetchStudyMode();
    this.fetchStudentType();
    this.getSessionData()
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  prepopulationP() {
    this.isLoadingPersonal = true;
    this.spinner.show();
    let payload: any = {
      StuId: this.StudentId
    };
    this.umsService.fetchPersonalDetails(payload).subscribe(
      (res) => {
        if (res && res.status) {
          this.ShowPersonal = true;
          if (res.data && Array.isArray(res.data) && res.data.length > 0) {
            const studentData = res.data[0];
            this.RgNo = studentData.StuRgNo;
            this.getRegData(studentData);
            sessionStorage.setItem("StudentDocumentID", studentData.StuId || '');
            this.prepopulatedatapageP(res);
          } else {
            this.loadsettingspageP();
          }
        } else {
          this.RgNo = this.StudentId
          this.ShowPersonal = false;
          this.spinner.hide();
          this.loadsettingspageP();
        }
        this.isLoadingPersonal = false;
      },
      (ERROR: HttpErrorResponse) => {
        this.ShowPersonal = false;
        this.spinner.hide();
        this.loadsettingspageP();
        this.isLoadingPersonal = false;
      }
    );
  }

  prepopulatedatapageP(e) {
    if (e.data[0]['StuFirstNameEng'] != null) {
      this.StudentName = e.data[0]['StuFirstNameEng'] + ' ' + e.data[0]['StuMidNameEng'] + ' ' + e.data[0]['StuLastNameEng']
    }
    else {
      this.StudentName = e.data[0]['StuFullNameEng']
    }
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.personalDetailsForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.personalDetailsForm.controls['StuRgNo'].setValue(e.data[0]['StuRgNo']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      if (ress.status) {
        this.spinner.hide();
        ress.data.forEach((element) => {
          if (element.FormVisible) {
            if (element.FormRequired) {
              if (element.FormPattern == '') {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

              }
              else {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));

              }
            } else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        });
        this.mapdataaa(ress.data);
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  loadsettingspageP() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        res.data.forEach((element) => {
          if (element.FormVisible) {
            if (element.FormRequired) {
              if (element.FormPattern == '') {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
              }
              else {
                this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
              }
            } else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(''));
            }
          }
        });

        this.mapdataaa(res.data);
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  updatePersonalDetails() {
    this.spinner.show();
    let submitpayload = this.personalDetailsForm.value;
    let da = this.personalDetailsForm.value.StuBirthDate;
    submitpayload['StuBirthDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    submitpayload['StuPassYr'] = parseInt(this.personalDetailsForm.value.StuPassYr);
    this.umsService.updatePersonalDetails(submitpayload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
        }
        else {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  checkLock() {
    this.spinner.show();
    this.route.queryParams.subscribe(
      params => {
        this.UpdateBtn = false;
        const payload = {};
        payload['UserId'] = params['UserId'];
        payload['StudentId'] = params['StudentId'];
        payload['SessionId'] = params['SessionId'];
        this.umsService.ScrutinyLock(payload).subscribe((res) => {
          if (res.status) {
            this.spinner.hide();
            let Data = res.data[0]
            if (Data.Status == 'APPR' && Data.FinalApproval == true && params['UserId'] == Data.HistoryUserId) {
              this.UpdateBtn = true;
              this.isformreadonly = true;
            }
            else {
              this.UpdateBtn = false;
            }

          } else {
            this.spinner.hide();
            this.UpdateBtn = false;
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
        }
        );
      })
  }

  mapdataaa(e) {
    this.personalDetailsFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
    this.personalData = true
    this.personalDetails();
  }

  ageCalculate() {
    let payload = this.personalDetailsForm.value;
    if (payload.StuBirthDate) {
      var timeDiff = Math.abs(
        Date.now() - new Date(payload.StuBirthDate).getTime()
      );
      let age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      this.personalDetailsForm.controls['StuAge'].setValue(age);
    }
  }

  fetchCountryP() {
    this.spinner.show();
    const payload = {};
    this.StateCodeListP = []
    this.filteredListStateP = []
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.umsService.getCountry(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.PCountryCodeList = res.data;
        this.filteredListPCountryCode = this.PCountryCodeList.slice();
      } else {
        this.spinner.hide();
        this.PCountryCodeList = []
        this.filteredListPCountryCode = []
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.PCountryCodeList = []
      this.filteredListPCountryCode = []
    })
  }

  fetchCountryC() {
    this.spinner.show();
    const payload = {};
    this.StateCodeListC = []
    this.filteredListStateC = []
    this.districtCodeListC = []
    this.filteredListDistrictC = []
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.filteredListStateC = []
    this.umsService.getCountry(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CCountryCodeList = res.data;
        this.CfilteredListCountryCode = this.CCountryCodeList.slice();
      } else {
        this.spinner.hide();
        this.CCountryCodeList = [];
        this.CfilteredListCountryCode = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CCountryCodeList = [];
      this.CfilteredListCountryCode = [];
    })
  }

  fetchStateP(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
        this.contactDetailsForm.controls["StuStateP"].setValue('');
      } else {
        this.spinner.hide();
        this.StateCodeListP = [];
        this.filteredListStateP = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.StateCodeListP = [];
      this.filteredListStateP = [];
    })
  }

  fetchStateP2(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        this.spinner.hide();
        this.StateCodeListP = [];
        this.filteredListStateP = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.StateCodeListP = [];
      this.filteredListStateP = [];
    })
  }

  fetchStateP3(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
      } else {
        this.spinner.hide();
        this.StateCodeListP = [];
        this.filteredListStateP = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.StateCodeListP = [];
      this.filteredListStateP = [];
    })
  }

  fetchStateC(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
        this.contactDetailsForm.controls["StuStateC"].setValue('');
      } else {
        this.spinner.hide();
        this.StateCodeListC = [];
        this.filteredListStateC = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.StateCodeListC = [];
      this.filteredListStateC = [];
    })
  }

  fetchStateC2(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
      } else {
        this.spinner.hide();
        this.StateCodeListC = [];
        this.filteredListStateC = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.StateCodeListC = [];
      this.filteredListStateC = [];
    })
  }

  fetchDistrictP(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
        this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      } else {
        this.spinner.hide();
        this.districtCodeListP = [];
        this.filteredListDistrictP = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.districtCodeListP = [];
      this.filteredListDistrictP = [];
    })
  }

  fetchDistrictP2(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        this.spinner.hide();
        this.districtCodeListP = [];
        this.filteredListDistrictP = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.districtCodeListP = [];
      this.filteredListDistrictP = [];
    })
  }

  fetchDistrictP3(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
      } else {
        this.spinner.hide();
        this.districtCodeListP = [];
        this.filteredListDistrictP = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.districtCodeListP = [];
      this.filteredListDistrictP = [];
    })
  }

  fetchDistrictC(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
        this.contactDetailsForm.controls["StuDistrictC"].setValue('');
      } else {
        this.spinner.hide();
        this.districtCodeListC = [];
        this.filteredListDistrictC = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.districtCodeListC = [];
      this.filteredListDistrictC = [];
    })
  }

  fetchDistrictC2(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
      } else {
        this.spinner.hide();
        this.districtCodeListC = [];
        this.filteredListDistrictC = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.districtCodeListC = [];
      this.filteredListDistrictC = [];
    })
  }

  getTehasilDataC(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilCList = res.data;
        this.filteredtehasilCList = this.tehasilCList.slice();
        this.contactDetailsForm.controls["StuTehsilC"].setValue('');
      }
      else {
        this.spinner.hide();
        this.tehasilCList = [];
        this.filteredtehasilCList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.tehasilCList = [];
      this.filteredtehasilCList = [];
    });
  }

  getTehasilDataC2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilCList = res.data;
        this.filteredtehasilCList = this.tehasilCList.slice();
      }
      else {
        this.spinner.hide();
        this.tehasilCList = [];
        this.filteredtehasilCList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.tehasilCList = [];
      this.filteredtehasilCList = [];
    });
  }

  getTehasilDataP(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilPList = res.data;
        this.filteredtehasilPList = this.tehasilPList.slice();
        this.contactDetailsForm.controls["StuTehsilP"].setValue('');
      }
      else {
        this.spinner.hide();
        this.tehasilPList = [];
        this.filteredtehasilPList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.tehasilPList = [];
      this.filteredtehasilPList = [];
    });
  }

  getTehasilDataP2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.tehasilPList = res.data;
        this.filteredtehasilPList = this.tehasilPList.slice();
      }
      else {
        this.spinner.hide();
        this.tehasilPList = [];
        this.filteredtehasilPList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.tehasilPList = [];
      this.filteredtehasilPList = [];
    });
  }

  fetchMarritalStatus() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'MarSt';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.marritalList = res.data;
        this.filteredmarritalstatusList = this.marritalList.slice();
      } else {
        this.spinner.hide();
        this.marritalList = [];
        this.filteredmarritalstatusList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.marritalList = [];
      this.filteredmarritalstatusList = [];
    });
  }

  fetchBloodGroup() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Bld';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.bloodgroupList = res.data;
        this.filteredBloodGroupList = this.bloodgroupList.slice();
      } else {
        this.spinner.hide();
        this.bloodgroupList = [];
        this.filteredBloodGroupList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.bloodgroupList = [];
      this.filteredBloodGroupList = [];
    });
  }

  copyAddress(e) {
    if (e.checked == true) {
      this.isreadonly = true;
      let payload = this.contactDetailsForm.value.StuAddrC;
      let payload2 = this.contactDetailsForm.value.StuCountryC;
      this.fetchStateP3(payload2);
      let payload3 = this.contactDetailsForm.value.StuStateC;
      this.fetchDistrictP3(payload3)
      let payload4 = this.contactDetailsForm.value.StuDistrictC;
      let payload6 = this.contactDetailsForm.value.StuCityC;
      let payload7 = this.contactDetailsForm.value.StuPinC;
      this.contactDetailsForm.controls["StuAddrP"].setValue(payload);
      this.contactDetailsForm.controls["StuCountryP"].setValue(payload2);
      this.contactDetailsForm.controls["StuStateP"].setValue(payload3);
      this.contactDetailsForm.controls["StuDistrictP"].setValue(payload4);
      this.contactDetailsForm.controls["StuCityP"].setValue(payload6);
      this.contactDetailsForm.controls["StuPinP"].setValue(payload7);

    }
    else {
      this.isreadonly = false;
      this.contactDetailsForm.controls["StuAddrP"].setValue('');
      this.contactDetailsForm.controls["StuCountryP"].setValue('');
      this.contactDetailsForm.controls["StuStateP"].setValue('');
      this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      this.contactDetailsForm.controls["StuCityP"].setValue('');
      this.contactDetailsForm.controls["StuPinP"].setValue('');
    }
  }


  updateContaceDetails() {
    this.spinner.show();
    let payload = this.contactDetailsForm.value;
    if (this.contactDetailsForm.value.StuSameAddr == 1 || this.contactDetailsForm.value.StuSameAddr == true) {
      payload['StuAddrP'] = this.contactDetailsForm.value.StuAddrC;
      payload['StuCountryP'] = this.contactDetailsForm.value.StuCountryC;
      payload['StuStateP'] = this.contactDetailsForm.value.StuStateC;
      payload['StuDistrictP'] = this.contactDetailsForm.value.StuDistrictC;
      payload['StuCityP'] = this.contactDetailsForm.value.StuCityC;
      payload['StuPinP'] = this.contactDetailsForm.value.StuPinC;
    }
    this.umsService.updateContactDetails(payload).subscribe(res => {
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  getSessionData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.sessionList = res.data;
        this.SessionFilterList = this.sTypeList.slice();
      }
      else {
        this.spinner.hide();
        this.sessionList = [];
        this.SessionFilterList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
      this.SessionFilterList = [];
    });
  }

  fetchGender() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      } else {
        this.spinner.hide();
        this.genderList = [];
        this.filteredGenderList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.genderList = [];
      this.filteredGenderList = [];
    });
  }

  fetchMotherTounge() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Lang';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.mothertoungList = res.data;
        this.filteredMotherToungList = this.mothertoungList.slice();
      } else {
        this.spinner.hide();
        this.mothertoungList = [];
        this.filteredMotherToungList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.mothertoungList = [];
      this.filteredMotherToungList = [];
    });
  }


  prepopulationC() {
    this.isLoadingContact = true;
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      if (res.status) {
        this.ShowContact = true;
        if (res.data.length > 0) {
          this.fetchStateC2(res.data[0].StuCountryC);
          this.fetchStateP2(res.data[0].StuCountryP);
          this.fetchDistrictC2(res.data[0].StuStateC);
          this.fetchDistrictP2(res.data[0].StuStateP);
          if (res.data[0].StuSameAddr == 1) {
            this.isreadonly = true;
          } else {
            this.isreadonly = false;
          }
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageC(res);
        } else {
          this.loadsettingspageC();
        }
      } else {
        this.spinner.hide();
        this.ShowContact = false;
        this.loadsettingspageC();
      }
      this.isLoadingContact = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowContact = false;
      this.loadsettingspageC();
      this.isLoadingContact = false;
    })
  }

  prepopulatedatapageC(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.contactDetailsForm.controls['StuAddrId'].setValue(e.data[0]['StuAddrId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.contactDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.ContactData = true;
    this.contactDetails();
  }

  loadsettingspageC() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(
              element.FormControlName,
              new FormControl('')
            );
          }
        }
      });
      this.contactDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.ContactData = true;
    this.contactDetails();
  }

  fetchCountry() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCountry(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CountryCodeList = res.data;
        this.filteredListCountryCode = this.CountryCodeList.slice();
      } else {
        this.spinner.hide();
        this.CountryCodeList = [];
        this.filteredListCountryCode = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CountryCodeList = [];
      this.filteredListCountryCode = [];
    })
  }

  fetchState() {
    this.spinner.show();
    const payload = {};
    this.umsService.getState(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.StateCodeList = res.data;
        this.filteredListState = this.StateCodeList.slice();
      } else {
        this.spinner.hide();
        this.StateCodeList = [];
        this.filteredListState = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.StateCodeList = [];
      this.filteredListState = [];
    })
  }

  fetchDistrict() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.districtCodeList = res.data;
        this.filteredListDistrict = this.districtCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  }

  fetchNationality() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'NL';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchDomicile() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Dm';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.domicileList = res.data;
        this.filteredDomicileList = this.domicileList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchRegion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Regio';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.regionList = res.data;
        this.filteredRegionList = this.regionList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }



  fetchPassYear() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'PaYr';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.PassYearList = res.data;
        this.filteredPassYearList = this.PassYearList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchCourseForQual() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Cours';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.courseQualList = res.data;
        this.filteredcourseList = this.courseQualList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchBoardUni() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'BOARD';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.boardUniList = res.data;
        this.filteredboardUniList = this.boardUniList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  prepopulationR() {
    this.isLoadingReservation = true;
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.ShowReservation = true;
        if (res.data.length > 0) {

          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.fetchMinorityType(res.data[0].StuMinorityType);
          this.StuMinorityTypeDisable2(res.data[0])
          this.fetchCast(res.data[0].StuConstiSubCate);
          this.prepopulatedatapageR(res);
        } else {
          this.loadsettingspageR();
        }
      } else {
        this.spinner.hide();
        this.ShowReservation = false;
        this.loadsettingspageR();
      }
      this.isLoadingReservation = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowReservation = false;
      this.isLoadingReservation = false;
    })
  }

  StuMinorityTypeDisable2(e) {
    if (e.StuMinority === 2 || e.StuMinority == 2) {
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    } else {
      this.isStuMinorityTypeDisable = false
      this.isStuMinorityType2Disable = false
    }
  }

  onSelectionCastCertificat2(e) {
    if (e == '2') {
      this.isStuCasteValCertDisable = true;
      this.isStuNonCrmValDtDisable = true;
      this.isStuNonCrmValDtDisable2 = true
    }
  }

  StuOrphanTypeDisable2(e) {
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
    }
    else if (e == 2) {
      this.isStuOrphanTypeDisable = true
    }
  }

  StuSpecialAbledTypeDisable2(e) {
    if (e == 1) {
      this.isStuSpecialAbledTypeDisable = false
    }
    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
    }
  }

  fetchMinorityType2(value) {
    this.spinner.show();
    this.disableMinority = false;
    const payload = {};
    if (value === 1) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else if (value === 2) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
    else {
      this.spinner.hide()
      this.isStuMinorityType2Disable = true;
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');
      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      payload['MinorityType'] = 3;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }

  prepopulatedatapageR(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.reservationsDetailsForm.controls['StuResId'].setValue(e.data[0]['StuResId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

        } else {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.reservationsDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.ReservationData = true;
    this.reservationDetails();
  }

  loadsettingspageR() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.reservationsDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
        }
      });
      this.reservationsDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.ReservationData = true;
    this.reservationDetails();
  }

  fetchMinorityType(value) {
    this.spinner.show();
    const payload = {};
    if (value === 1) {
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else {
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }

  fetchCast(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;
      this.spinner.show()
      const payload = {};
      this.categoryList = [];
      this.filteredCategoryList = [];
      payload['CategoryId'] = value;
      this.umsService.fetchCategory(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.categoryList = res.data;
          this.filteredCategoryList = this.categoryList.slice();
        }
        else {

        }

      });
    }


  }

  fetchCast2(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.get('StuCaste').patchValue('');
      this.reservationsDetailsForm.get('StuCasteCert').patchValue(2);
      this.reservationsDetailsForm.get('StuCasteValCert').patchValue(3);
      this.reservationsDetailsForm.get('StuNonCrmCert').patchValue(2);
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.reservationsDetailsForm.get('StuInHouse').patchValue(2);
      this.reservationsDetailsForm.get('StuMinority').patchValue(2);
      this.reservationsDetailsForm.get('StuMinorityType').patchValue(3);
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');

      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;

    }

    this.spinner.show()
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CategoryId'] = value;
    this.umsService.fetchCategory(payload).subscribe((res) => {
      this.spinner.hide()
      if (res.status) {
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        //this.castGene(payload)
      }
      else {

      }

    });
  }

  fetchReligion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Reg';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.religionList = res.data;
        this.filteredReligionList = this.religionList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchSpAbled() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SpAb';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.specialAbledList = res.data;
        this.filteredspecialAbledList = this.specialAbledList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchorphanType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Op';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.orphanTypeList = res.data;
        this.filteredorphanTypeList = this.orphanTypeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchConstiCate() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchSocialReservation() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.SRList = res.data;
        this.filteredSR = this.SRList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  prepopulationQ() {
    this.isLoadingQualification = true;
    this.spinner.show();

    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {

      if (res.status) {
        this.ShowQualify = true;
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageQ(res);
        } else {
          this.loadsettingspageQ();
        }
      } else {
        this.spinner.hide();
        this.ShowQualify = false;
        this.loadsettingspageQ();
      }
      this.isLoadingQualification = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowQualify = false;
      this.isLoadingQualification = false;
    })
  }

  prepopulatedatapageQ(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e.data[0]['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName],));

        } else {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

    this.fetchQualDetailsForTable();
    this.fetchBoardUni();
    this.fetchCourseForQual();
    this.fetchPassYear();
    this.QualificationData = true;
  }

  loadsettingspageQ() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.qualificationDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });

    this.fetchQualDetailsForTable();
    this.fetchBoardUni();
    this.fetchCourseForQual();
    this.fetchPassYear();
    this.QualificationData = true;
  }

  fetchQualDetailsForTable() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    payload['StuQualId'] = '';
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.qualList = res.data;
      if (res.data.length == 0) {
        this.isDivShow = false;
      }
      else {
        this.isDivShow = true;
      }
    })
  }

  onSelectionChanged2({ value }) {
    if (value = 2) {
      this.resultNotDec = true;
      this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();
      this.qualificationDetailsForm.get('fileUploadData').markAsUntouched();
      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuPercent'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPercent'].clearValidators();
      this.qualificationDetailsForm.controls['StuPercent'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuCgpi'].setErrors(null);
      this.qualificationDetailsForm.controls['StuCgpi'].clearValidators();
      this.qualificationDetailsForm.controls['StuCgpi'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();

      this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
      this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
      this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();

    } else {
      this.resultNotDec = false;
    }
  }

  onselectPrepopulate(e) {
    this.spinner.show();
    this.onSelectionChanged2(e);
    this.qualificationDetailsFormArray = [];
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
          this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);

        }
        else if (element.FormVisible == false) {
          // this.qualificationDetailsForm.controls[element.FormControlName].setValue('');
        }
      }

      );
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));

    });

  }

  prepopulationA() {
    this.isLoadingAdditional = true;
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.ShowAddit = true;
        if (res.data.length > 0) {
          this.fetchDate(res.data)
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageA(res);
        } else {
          this.loadsettingspageA();
        }
      } else {
        this.spinner.hide();
        this.ShowAddit = false;
        this.loadsettingspageA();
      }
      this.isLoadingAdditional = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowAddit = false;
      this.isLoadingAdditional = false;
    })
  }

  prepopulatedatapageA(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.additionalDetailsForm.controls['StuExtraId'].setValue(e.data[0]['StuExtraId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

        } else {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.additionalDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.AdditionalData = true;
  }

  loadsettingspageA() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(''));

        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.AdditionalData = true;
  }


  prepopulationPS() {
    this.isLoadingPhotoSign = true;
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      this.spinner.hide();

      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      if (res.status) {
        this.ShowPhoto = true;
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
          this.photoSignDetailsForm = this.fb.group({
            StuId: new FormControl(data.StuId),
            StuRgNo: new FormControl(data.StuRgNo),
            StuPhoto: new FormControl(data.StuPhoto),
            StuSignature: new FormControl(data.StuSignature),
          });
          this.userImage = res.data[0].StuPhoto
          this.signatureImage = res.data[0].StuSignature
        }
        else {
        }
      } else {
        this.ShowPhoto = false;
      }
      this.isLoadingPhotoSign = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowPhoto = false;
      this.isLoadingPhotoSign = false;
    })
    this.PhotoSignData = true;
  }

  fetchDate(item) {
    if (item[0].StuFromDate == "1970-01-01" && item[0].StuToDate == "1970-01-01") {
      item[0].StuFromDate = '';
      item[0].StuToDate = ''
    }
  }

  prepopulationAD() {
    this.isLoadingAdmission = true;
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.ShowAdmission = true;
        this.getFeeTempData(res.data[0].SessionId, res.data[0].StuCoId, res.data[0].StuCgId, res.data[0].StuId)

        res.data[0].StuBrId = parseInt(res.data[0].StuBrId);
        res.data[0].StuEmId = parseInt(res.data[0].StuEmId);
        this.getExamForLateral(res.data[0].StuEmId);
        res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(",")
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          sessionStorage.setItem("StuAcadId", res.data[0].StuAcadId);

          this.getCourseData(res.data[0].StuFacId);
          this.getExamStreamData(res.data[0].StuCoId, res.data[0].StuBrId);
          this.selectedValues = res.data[0].StuSubjectRg;
          const dataArray = res.data[0].StuSubjectRgCopy.split(',');
          dataArray.forEach(item => {
            const splitValues = item.split('-');
            const obj = {
              Code: splitValues[0],
              Id: splitValues[1]
            };
            this.newSelectedValues.push(obj);
          });
          this.prepopulatedatapageAD(res);

        } else {
          this.showchat = true;
          this.loadsettingspageAD();
        }
      }
      else {
        this.spinner.hide();
        this.ShowAdmission = false;
        this.loadsettingspageAD();
      }
      this.isLoadingAdmission = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowAdmission = false;
      this.isLoadingAdmission = false;
    })
  }

  getExamForLateral(id) {
    const payload2 = {};
    payload2['EmId'] = id;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
    });
  }
  shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);
  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === item1.EsId);
  }

  getBrId(id) {
    this.BranchId = id;
  }

  getSubData(id) {
    this.spinner.show()
    const payload = {};
    payload['EsEmId'] = id.EmId;
    payload['EsStrId'] = this.BranchId;
    this.umsService.fetchSubs(payload).subscribe(res => {
      this.spinner.hide()
      this.ErrorMessage = '';
      this.SubError = false;
      this.Subjects = [];
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.MinMax = false;
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
    });
  }

  prepopulatedatapageAD(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';

    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

        }
        else {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.admissionDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.AdmissionData = true;
    this.admissionDetails();
  }

  loadsettingspageAD() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this.admissionDetailsForm.addControl(
            element.FormControlName,
            new FormControl('')
          );
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    });
    this.AdmissionData = true;
    this.admissionDetails();
  }

  getFacultyData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      this.spinner.hide();
      this.facultyList = res.data;
      this.filteredFacultyList = this.facultyList.slice();
    });
  }

  fetchStudyMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.studyModeList = res.data;
        this.filteredstudyModeList = this.studyModeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchStudentType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.sTypeList = res.data;
        this.filteredsTypeList = this.sTypeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  onCheckbox(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
    this.validateCheckboxesForItem();
  }

  validateCheckboxesForItem(): void {
    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );

      this.validateCheckboxes(item, selectedForItem);
    }
  }

  validateCheckboxes(item: any, selectedCheckboxes: any[]): void {
    const totalSelected = selectedCheckboxes.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    if (totalSelected < opMin || totalSelected > opMax) {
      this.validationErrors[item.OpCode] = `Selected checkboxes should be between ${opMin} and ${opMax}`;
    } else {
      delete this.validationErrors[item.OpCode];
    }
  }


  getCourseData(id) {
    this.spinner.show();
    const payload = {};
    payload['CoFcCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredCourseList = this.courseList.slice();
    });
  }

  getExamStreamData(id, StrId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data.length > 0) {
        res.data.forEach(element => {

        });

        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.showchat = true;
      } else {
        this.showchat = true;
      }

    },
    );

    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
      this.examList = res.data;
      this.filteredExamList = this.examList.slice();
    });

    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.courseClg(payload3).subscribe(res => {
      this.spinner.hide();
      this.stucourseClgMapList = res.data;
      this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
    });

  }

  fetchDocument() {
    this.isLoadingDocument = true;
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.ducumentList = res.data;
      if (res.data.length == 0) {
        this.ShowDoc = true;
        this.isDivShow = false;
      }
      else {
        this.ShowDoc = false;
        this.isDivShow = true;
      }
      this.isLoadingDocument = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ShowDoc = false;
      this.isLoadingDocument = false;
    });
    this.DocumentData = true;
  }

  fetchForupdate(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = data.StuId;
    payload['StuDocId'] = data.StuDocId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      let data = res.data[0];


      sessionStorage.setItem('StuDocId', data.StuDocId)
      if (res.status) {
        let StuRemarkCheck = false;
        if (data.StuRemarkCheck == 1) {
          StuRemarkCheck = true;
        } else {
          StuRemarkCheck = false;
        }
        this.documentDetailsForm = this.fb.group({
          arrData: this.fb.array([]),
          StuId: new FormControl(data.StuId),
          StuSrNo: new FormControl(data.StuSrNo, [Validators.required]),
          StuDocumentName: new FormControl(data.StuDocumentName, Validators.required),
          StuRemark: new FormControl(data.StuRemark, Validators.required),
          StuFileUpload: new FormControl(data.StuFileUpload),
          StuRemarkConfirm: new FormControl(data.StuRemarkConfirm),
          StuRemarkCheck: new FormControl(StuRemarkCheck),
        });
        let preArr = [];
        const tmpDict = {};
        tmpDict['StuId'] = new FormControl(data.StuId);
        tmpDict['StuSrNo'] = new FormControl(data.StuSrNo, [Validators.required]);
        tmpDict['StuDocumentName'] = new FormControl(data.StuDocumentName),
          tmpDict['StuRemark'] = new FormControl(data.StuRemark);
        tmpDict['StuFileUpload'] = new FormControl(data.StuFileUpload);
        tmpDict['StuRemarkConfirm'] = new FormControl(data.StuRemarkConfirm);
        tmpDict['StuRemarkCheck'] = new FormControl(data.StuRemarkCheck);
        const creds = this.documentDetailsForm.controls.arrData as FormArray;
        creds.push(new FormGroup(tmpDict));
      } else {
      }

    });

  }

  showbase64(e) {
    const dialogRef3 = this.dialog.open(PdfViewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.fileUploadData
      });
  }

  showbase642(e) {
    const dialogRef3 = this.dialog.open(PdfViewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.StuFileUpload
      });
  }

  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back();
  }

  getExamSubMapFetch(EmId, BranchId) {
    this.Subjects = [];
    this.GroupData = [];
    this.Subs = false;
    this.OptSub = false;
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = BranchId;
    this.umsService.getExamSubMapFetch(payload).subscribe(async res => {
      this.spinner.hide();
      this.SubjectData = res.data.children;
      this.SubjectData.forEach(element => {
        if (element.EsType == 'S') {
          this.Subs = true;
          if (this.Subjects.indexOf(element.EsCode) === -1) {
            this.Subjects.push(element.EsCode);
            this.SubjectName.push(element.EsName);
            this.Sub.push(element.EsOpCode)
            this.AllSub.push(element)
            if (element.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element.EsOpCode);
              }
            }
          }
          if (element.EsOpCode == " " && element.EsType == 'S') {
            const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
            if (!isDuplicate) {
              this.selectedCheckboxes.push(element);
            }
          }
          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsParent) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }
          })
        }
        else if (element.EsType == 'G') {
          this.OptSub = true;
          if (element.EsOpCode !== ' ') {
            const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
            if (!DupOpt) {
              this.selectedOptions.push(element.EsOpCode);
            }
          }
          const isDuplicate = this.GroupData.some((item: any) => item.EsId === element.EsId);
          if (!isDuplicate) {
            this.GroupData.push(element);
          }
          element.children.forEach(element1 => {
            if (element1.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element1.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element1.EsOpCode);
              }
            }

            if (element1.EsOpCode == " ") {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element1);
              }
            }

            this.newSelectedValues.forEach(element2 => {
              if (element2.Code == element1.EsCode && element2.Id == element1.EsParent) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element1);
                }

              }

            })
          });

          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsId) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }

          })
          for (const value of this.newSelectedValues) {
            element.children.forEach(element2 => {
              if (element2.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element2.EsOpCode);
                }
              }
            });
          }

        }
      });
      await this.getOptionData(EmId, BranchId);
    });


  }


  getOptionData(EmId, BranchId) {
    this.optData = '';
    this.spinner.show();
    const payload = {};
    payload['OpEmId'] = EmId;
    payload['OpStrId'] = BranchId;
    this.umsService.getOption(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status == true) {
        const filteredArray = res.data.filter(item => this.selectedOptions.includes(item.OpCode));
        this.optData = filteredArray;
        this.MinMax = true;
      }
      else {
        this.MinMax = false;
      }
    });
  }

  onSelectionCastCertificat(e) {
    if (e === '1') {
      this.isStuCasteValCertDisable = false
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue('')
    } else {
      this.isStuCasteValCertDisable = true
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue(2)
    }
  }

  StuNonCrmValDtDisable(e) {
    if (e === '1' || e === 1) {
      this.isStuNonCrmValDtDisable = false
      this.reservationsDetailsForm.controls['StuNonCrmValDt'].setValue(2)
    } else {
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.isStuNonCrmValDtDisable = true
    }
  }

  StuOrphanTypeDisable(e) {
    this.isStuOrphanTypeDisable = false
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('')
    } else {
      this.isStuOrphanTypeDisable = true
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('NA')
    }
  }

  StuSpecialAbledTypeDisable(e) {
    this.isStuSpecialAbledTypeDisable = false
    if (e == 1) {

      this.isStuSpecialAbledTypeDisable = false
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('')
    }

    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('NA')

    }
  }



  StuMinorityTypeDisable(e) {
    if (e === 1) {
      this.isStuMinorityTypeDisable = false
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue('')
      this.isStuMinorityType2Disable = false
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue('')
    } else {
      this.isStuMinorityTypeDisable = true
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue(3)
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue(18)

    }
  }

  getRegData(data) {
    const payload = {}
    payload['RgNo'] = data['StuRgNo']
    this.umsService.SearchRegn(payload).subscribe((res) => {
      // this.ExamData(res.data[0])
      this.getData(res.data[0])
    })
  }


  fetchCertStatus() {
    this.isLoadingCertStatus = true;
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CertS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.CertList = res.data;
        // Update the description for the 'APR' CdCode based on conditions
        this.CertList = this.CertList.map((item) => {
          if (item.CdCode === 'APR') {
            item.CdDesc =
              this.Tclcdata['CertType'] === 'TS'
                ? 'Download Provisional Certificate'
                : 'Generate Certificate';
          }
          return item;
        });
        // Filter the list dynamically based on conditions
        this.filteredCertList = this.CertList.filter((item) => {
          if (this.Tclcdata['CertType'] === 'ADMC') {
            const App = 'APR';
            const Status = 'REJ';
            const UDF = 'UFD'
            return item.CdCode !== App && item.CdCode !== Status && item.CdCode !== UDF;
          } else if (this.Tclcdata['CertType'] === 'TS') {
            const App = 'APPAP';
            const Status = 'REJ';
            return item.CdCode !== App && item.CdCode !== Status;
          } else if (this.Tclcdata['CertType'] == 'TC') {
            // const App = 'UFD';
            // return item.CdCode !== App
            if (this.userPermission[0]?.CgUi === 'C') {
              if (this.Tclcdata['DestClg'] === this.userPermission[0]?.CgId) {
                const App = 'APR';
                const UDF = 'UFD';
                const Rec = 'REC'
                return item.CdCode !== App && item.CdCode !== UDF && item.CdCode !== Rec;
              }
              else {
                const UDF = 'UFD'
                const Rec = 'REC'
                return item.CdCode !== UDF && item.CdCode !== Rec;
              }
            }
            else {

              const UDF = 'UFD'
              const Rec = 'REC'
              return item.CdCode !== UDF && item.CdCode !== Rec;
            }
          }
          else {
            if (this.userPermission[0]?.CgUi === 'C') {
              if (this.Tclcdata['DestClg'] === this.userPermission[0]?.CgId) {
                const App = 'APR';
                const UDF = 'UFD';
                const Rec = 'REC'
                return item.CdCode !== App && item.CdCode !== UDF && item.CdCode !== Rec;
              }
              else {
                const UDF = 'UFD'
                const Rec = 'REC'
                return item.CdCode !== UDF && item.CdCode !== Rec;
              }
            }
            else {

              const UDF = 'UFD'
              const Rec = 'REC'
              return item.CdCode !== UDF && item.CdCode !== Rec;
            }
            return true;
          }
        });

        // ===== NEW: Ensure currently saved CertStatus is present in filtered list =====
        // So when admin re-opens page after a Reject (REJ) etc., the dropdown pre-populates
        const currentStatus = this.Tclcdata?.['CertStatus'];
        if (currentStatus && !this.filteredCertList.some(x => x.CdCode === currentStatus)) {
          const currentItem = this.CertList.find(x => x.CdCode === currentStatus);
          if (currentItem) {
            this.filteredCertList.unshift(currentItem);
          }
        }

        // ===== NEW: Populate Action dropdown with saved status (re-fetch behaviour) =====
        if (this.CertScrutinyForm) {
          this.CertScrutinyForm.get('CertStatus')?.setValue(currentStatus || '');
        }
        // ===== END NEW =====
      } else {
        this.spinner.hide();
      }
      this.isLoadingCertStatus = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.isLoadingCertStatus = false;
    });
  }


  Save() {
    if (this.CertScrutinyForm.invalid) {
      this.CertScrutinyForm.get('CertStatus').markAsTouched();
    }
    else {
      this.Submit()
    }
  }

  Submit() {
    if (this.CertScrutinyForm.value['CertStatus'] === 'APPAP') {
      if (this.Tclcdata['CertType'] === 'ADMC' && this.AdmFeesPaid === true) {
        this.SubmitScrutiny()
      }
      else if (this.Tclcdata['CertType'] === 'ADMC' && this.AdmFeesPaid == false) {
        let data = {}
        data['message'] = 'Admission Fees Not Paid!'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
      else if (this.Tclcdata['CertType'] === 'TC' || this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'TS') {
        if (this.Tclcdata['FeeStatus'] === 'Y' && (this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'TS')) {
          let data = {}
          data['message'] = 'Application Already Approved'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
        else if (this.Tclcdata['FeeStatus'] === 'Y' && this.Tclcdata['CertType'] === 'TC') {
          if (this.userPermission[0].CgUi == 'C') {
            if (this.userPermission[0].CgId == this.Tclcdata['StuCollege']) {
              if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "APR" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
                // this.SubmitScrutiny()
                let data = {}
                data['message'] = 'Application Already Approved'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              }
              else if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
                let data = {}
                data['message'] = 'Application Still Not Approved By Destination College'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              }
              else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
                let data = {}
                data['message'] = 'Application Rejected By Destination College'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              }
            }
            else if (this.userPermission[0].CgId == this.Tclcdata['DestClg']) {
              if (this.Tclcdata['CertStatus'] == "APR") {
                let data = {}
                data['message'] = 'Already Certificate Generated'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              } else {
                this.SubmitScrutiny()
              }

            }

          }
          else {
            if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
              let data = {}
              data['message'] = 'Application Still Not Approved By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
              let data = {}
              data['message'] = 'Application Rejected By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "APPAP") {

              this.SubmitScrutiny()
            }
            else {
              this.SubmitScrutiny()
            }

          }
        }
        else if (this.Tclcdata['FeeStatus'] != 'Y' && (this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'TC')) {
          this.SubmitScrutiny()
        }
        else {
          this.SubmitScrutiny()
        }




      }

    }
    else if (this.CertScrutinyForm.value['CertStatus'] === 'APR') {
      if ((this.Tclcdata['CertType'] === 'TC' || this.Tclcdata['CertType'] === 'LC' || this.Tclcdata['CertType'] === 'MC' || this.Tclcdata['CertType'] === 'TS') && this.Tclcdata['FeeStatus'] != 'Y') {
        let data = {}
        data['message'] = 'Application Fees Not Paid!'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
      else if ((this.Tclcdata['CertType'] === 'TC') && this.Tclcdata['FeeStatus'] === 'Y') {
        if (this.userPermission[0].CgUi == 'C') {
          if (this.userPermission[0].CgId == this.Tclcdata['StuCollege']) {
            if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "APR")) {
              this.SubmitScrutiny()
            }
            else if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
              let data = {}
              data['message'] = 'Application Still Not Approved By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
            else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
              let data = {}
              data['message'] = 'Application Rejected By Destination College'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
          }
          else if (this.userPermission[0].CgId == this.Tclcdata['DestClg']) {
            let data = {}
            data['message'] = 'You Cannot Generate Certificate. You Can Approve Or Reject Only'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }

        }
        else {
          if (this.Tclcdata['DestClg'] != this.Tclcdata['ScrutinyBy'] && (this.Tclcdata['CertStatus'] == "APPAP" || this.Tclcdata['CertStatus'] == "ReSubmitted" || this.Tclcdata['CertStatus'] == "Fees Paid")) {
            let data = {}
            data['message'] = 'Application Still Not Approved By Destination College'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
          else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "REJ") {
            let data = {}
            data['message'] = 'Application Rejected By Destination College'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
          else if (this.Tclcdata['DestClg'] == this.Tclcdata['ScrutinyBy'] && this.Tclcdata['CertStatus'] == "APPAP") {

            this.SubmitScrutiny()
          }
          else {
            this.SubmitScrutiny()
          }

        }
      }
      else {
        this.SubmitScrutiny()
      }
    }
    else if (this.CertScrutinyForm.value['CertStatus'] === 'REJ') {

      // ===== NEW: Allow free Reject submission for ASC / RET / LANG / ATTFE / VOD =====
      if (this.Tclcdata['CertType'] === 'ASC' ||
          this.Tclcdata['CertType'] === 'RET' ||
          this.Tclcdata['CertType'] === 'LANG' ||
          this.Tclcdata['CertType'] === 'ATTFE' ||
          this.Tclcdata['CertType'] === 'VOD') {
        this.SubmitScrutiny()
      }
      // ===== END NEW =====
      else if (this.Tclcdata['CertType'] === 'TS') {
        if (this.Tclcdata['CertStatus'] === 'UFD') {
          let data = {}
          data['message'] = 'Certificate Already Generated, Cannot Reject Now'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          // this.SubmitScrutiny()
        }
        else {
          this.SubmitScrutiny()
        }

      }
      else {
        if (this.Tclcdata['FeeStatus'] === 'Y') {

          if (this.userPermission[0].CgUi == 'C') {
            if (this.userPermission[0].CgId == this.Tclcdata['DestClg']) {
              if (this.Tclcdata['CertStatus'] == "APR") {
                let data = {}
                data['message'] = 'Already Certificate Generated'
                data['title'] = 'Information'
                data['icon'] = 'fas fa-close'
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
              } else {
                this.SubmitScrutiny()
              }
              // this.SubmitScrutiny()
            }

            else {
              let data = {}
              data['message'] = 'Application Fees Already Paid, Cannot Reject Now'
              data['title'] = 'Information'
              data['icon'] = 'fas fa-close'
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            }
          }
          else {
            let data = {}
            data['message'] = 'Application Fees Already Paid, Cannot Reject Now'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }

        }
        else {
          this.SubmitScrutiny()
        }
      }

    }

    else {
      this.SubmitScrutiny()
    }
  }

   SubmitScrutiny() {
    const payload = {}
    let submitpayload = this.CertScrutinyForm.value
    // ===== NEW: fallbacks so ASC / RET / LANG / ATTFE / VOD (which don't have these) don't send undefined =====
    payload['StuFaculty'] = this.Tclcdata['StuFaculty'] || '',
      payload['StuCourse'] = this.Tclcdata['StuCourse'] || this.Tclcdata['CoName'] || '',
      payload['StuCollege'] = this.Tclcdata['StuCollege'] || this.Tclcdata['CgName'] || '',
      payload['StuExam'] = this.Tclcdata['StuExam'] || this.Tclcdata['EmName'] || '',
      payload['StuBranch'] = this.Tclcdata['StuBranch'] || '',
      // ===== END NEW =====
      payload['SnNo'] = this.Tclcdata['SnNo'],
      payload['CertType'] = this.Tclcdata['CertType'],
      payload['DestClg'] = this.Tclcdata['DestClg'],
      payload['Reason'] = this.Tclcdata['Reason'],
      payload['FeeStatus'] = this.Tclcdata['FeeStatus'],
      payload['CertStatus'] = submitpayload['CertStatus'];
    payload['StuId'] = this.Tclcdata['StuId'],
      payload['TclcId'] = this.Tclcdata['TclcId'],
      payload['Comment'] = submitpayload['Comment'],
      payload['CertScr'] = submitpayload['CertStatus'],
      payload['StatusBy'] = sessionStorage.getItem('userId')
    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if (res.status) {
        this.DocUploaded = true;
        this.SaveDisabled = true;
        this.spinner.hide()
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.DocUploaded = true;
          this.SaveDisabled = true;

          // ===== NEW: update Tclcdata with the just-submitted status/comment =====
          // So when the page re-opens (or when getScrData returns), it has the latest value
          this.Tclcdata['CertStatus'] = submitpayload['CertStatus'];
          this.Tclcdata['Comment'] = submitpayload['Comment'] || '';
          // ===== END NEW =====

          this.tclc = []
          this.tclc.push(payload)
          this.getScrData();
          this.SaveDisabled = true
          if (this.CertScrutinyForm.value['CertStatus'] === 'UFD' && this.CertScrutinyForm.value['CertType'] === 'TS') {
            this.UploadedDocs();
          }
        })
      } else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.getScrData()
        })
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

   getScrData() {
    const payload = {}
    payload['CertType'] = this.Tclcdata['CertType']
    payload['StuId'] = this.Tclcdata['StuId']
    this.umsService.GetCertScr(payload).subscribe((res) => {
      if (res.status && res.data && res.data.length > 0) {

        // ===== NEW: Pick the LATEST record from history =====
        // Sort by CertScr_Id descending (higher id = latest) so we always get the newest status
        const sortedData = [...res.data].sort((a, b) => {
          return (b.CertScr_Id || 0) - (a.CertScr_Id || 0);
        });
        const latestRecord = sortedData[0];

        // Save the latest CertScr_Id
        this.CertScrId = latestRecord['CertScr_Id'];

        // ===== NEW: Update Tclcdata with the latest status so dropdown/save logic works =====
        if (latestRecord.CertStatus) {
          this.Tclcdata['CertStatus'] = latestRecord.CertStatus;
        }
        this.Tclcdata['Comment'] = latestRecord.Comment || '';

        // ===== NEW: Patch the CertScrutinyForm so the Action dropdown shows the saved value =====
        if (this.CertScrutinyForm) {
          this.CertScrutinyForm.patchValue({
            CertStatus: latestRecord.CertStatus || '',
            Comment: latestRecord.Comment || ''
          });

          // Make sure the saved status exists in filteredCertList
          if (latestRecord.CertStatus && this.filteredCertList &&
              !this.filteredCertList.some(x => x.CdCode === latestRecord.CertStatus)) {
            const currentItem = this.CertList?.find(x => x.CdCode === latestRecord.CertStatus);
            if (currentItem) {
              this.filteredCertList.unshift(currentItem);
            }
          }
        }
        // ===== END NEW =====

        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  isOptionDisabled(item) {
    if (this.Tclcdata['CertType'] === 'ADMC') {
      const App = 'APR';
      const Status = 'REJ';
      return item === App || item === Status;
    }
    else if (this.Tclcdata['CertType'] === 'TS') {
      const App = 'APPAP';
      const Status = 'REJ';
      return item === App || item === Status
    }
    else {
      if (this.userPermission[0].CgUi == 'C') {
        if (this.Tclcdata['DestClg'] == this.userPermission[0].CgId) {
          const App = 'APR';
          return item === App
        }
      }
      else {
        return false
      }
    }
  }

  getFeeTempData(SnNo, CoCode, CgCode, StuId) {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = SnNo,
      payload['CoCode'] = CoCode;
    payload['CgCode'] = CgCode;
    payload['StuId'] = StuId;
    payload['FeeType'] = 'AF';
    this.umsService.SearchFeeAdm(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.AdmFee(res.data[0].TemplateCode, SnNo, StuId)

      } else {
        this.AdmFeesPaid = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.AdmFeesPaid = false
    });
  }

  AdmFee(TemplateCode, SnNo, StuId) {
    const payload = {};
    payload['FeeTemplateCode'] = TemplateCode;
    payload['StuId'] = StuId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = SnNo
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const totalFeeAmount = res.data.reduce((sum, item) => sum + item.FeeAmount, 0);
        if (res.data[0].TotalPaidAmount === totalFeeAmount) {
          this.AdmFeesPaid = true
          this.FeesData = res.data
        }
        else {
          this.AdmFeesPaid = false
        }

      } else {
        this.AdmFeesPaid = false
      }
    }, (ERROR: HttpErrorResponse) => {
      this.AdmFeesPaid = false
    });

  }

  History() {
    let data = {};
    data['CertType'] = this.Tclcdata['CertType'];
    data['StuId'] = this.Tclcdata['StuId']
    this.dialogRef1 = this.dialog.open(TclcHistoryComponent, {
      disableClose: true,
      width: "900px",
      height: "600px",
      data,
    });
    this.dialogRef1.afterClosed().subscribe((result) => {
    });
  }

  GetTranscript(StuId: number) {
    this.isLoadingTranscript = true;
    this.spinner.show()
    let payload = {};
    payload['StuId'] = StuId
    this.umsService.SearchTranscript(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.TranscriptData = res.data
        if (this.Tclcdata['CertType'] == 'TS') {
          this.Transcript = true
          this.StudentName = this.TranscriptData[0].StuName
          this.FetchApplyUni(res.data[0].IsWES)
        } 
        else if (this.Tclcdata['CertType'] == 'ATTFE') {
          this.Transcript = false
        }
        else if (this.Tclcdata['CertType'] == 'VOD') {
          this.Transcript = false
        }
      } else {
        this.spinner.hide()
        this.Transcript = false
      }
      this.isLoadingTranscript = false;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.isLoadingTranscript = false;
    })
  }

  getTclcDocs(StuId) {
    this.isLoadingTclcDocs = true;
    let payload = {};
    payload['SessionId'] = this.Tclcdata['SnNo'],
    payload['CertType'] = this.Tclcdata['CertType'],
    payload['TclcId'] = this.Tclcdata['TclcId'] || 0
    this.umsService.GetTcLcDocDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          this.TclcDocData = res.data.filter(record => record.StuId == StuId);
          if (this.TclcDocData != '' && this.TclcDocData.length > 0) {
            this.TclcDoc = true;
            console.log('Documents loaded for', this.Tclcdata['CertType'], this.TclcDocData);
          }
          else {
            this.TclcDoc = false;
          }
        }
        else {
          this.TclcDoc = false;
        }
        this.isLoadingTclcDocs = false;
      },
      (error) => {
        console.error('Error fetching documents:', error);
        this.TclcDoc = false;
        this.isLoadingTclcDocs = false;
      }
    );
  }

  showbase643(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "80%",
        data: e
      });
  }

  selectedRequest(data) {
    // if(this.tclc[0]['CertStatus'] == data){
    //   this.SaveDisabled = true
    // }
    // else{
    //   this.SaveDisabled = false
    // }

    if (data == 'APR' && this.Tclcdata['CertType'] == 'TS') {
      // this.openUploadDocumentPopUp()
      this.Print();
    }
    else if (data == 'UFD' && this.Tclcdata['CertType'] == 'TS') {
      this.openUploadDocumentPopUp()
    }

    // ===== NEW: Free selection for ASC / RET / LANG / ATTFE / VOD — always enable Submit =====
    if (this.Tclcdata['CertType'] === 'ASC' ||
        this.Tclcdata['CertType'] === 'RET' ||
        this.Tclcdata['CertType'] === 'LANG' ||
        this.Tclcdata['CertType'] === 'ATTFE' ||
        this.Tclcdata['CertType'] === 'VOD') {
      this.SaveDisabled = false;
      return;
    }
    // ===== END NEW =====

    if (data == 'REC' && this.Tclcdata['CertStatus'] == 'UFD') {
      this.SaveDisabled = true
    } else {
      this.SaveDisabled = false
    }

  }

  getData(data) {
    this.spinner.show();
    const payload = {}
    payload['ShId'] = '',
      payload['EfCate'] = '',
      payload['CgCode'] = '',
      payload['Cent'] = '',
      payload['RollNo'] = '',
      payload['RgName'] = '',
      payload['Sex'] = '',
      payload['StrCode'] = '',
      payload['PassFail'] = '',
      payload['EfStatus'] = '',
      payload['EfBatch'] = '',
      payload['WH'] = '',
      payload['Inc'] = '',
      payload['Decl'] = '',
      payload['EfPCFr'] = '',
      payload['EfPCTo'] = '',
      payload['RgNo'] = data.RgNo
    this.umsService.searchExmList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        // Find the exam with the highest EfShId
        const maxEfShIdExam = res.data.reduce((max, exam) => (exam.EfShId > max.EfShId ? exam : max), res.data[0]);

        // Set examData with the single object with the greatest EfShId and initialize subjects
        this.examData = [{ ...maxEfShIdExam, subjects: [] }];

        // Fetch subjects for this exam
        this.SubData(maxEfShIdExam);


      } else {
      }


    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  SubData(exam) {

    this.spinner.show();
    const payload = {};
    payload['FsEfId'] = exam.EfId
    this.umsService.SearchExamSub(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        // Update the subjects array for the single exam in examData
        this.examData[0].subjects = res.data;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  dowload(data) {
    const link = document.createElement("a");
    link.href = data;
    link.download = 'Download';
    link.click()
  }

  openUploadDocumentPopUp() {
    console.log('Tclcdata:', this.Tclcdata);
    console.log('Emid value:', this.Tclcdata?.Emid);
    let data = {};
    data['StuId'] = this.Tclcdata['StuId'];
    data['Emid'] = this.Tclcdata['StuExam'];
    data['StuSubId'] = this.Tclcdata['StuSubId'];
    data['CertType'] = this.Tclcdata['CertType'];
    data['TclcId'] = this.Tclcdata['TclcId'];
    
    const dialogRef4 = this.dialog.open(TcDocumentUploadComponent,
      {
        disableClose: true,
        width: '170vh',
        height: 'auto',
        data,
      });
    dialogRef4.afterClosed().subscribe((result) => {
      if (this.Tclcdata['CertType'] === 'ASC' || this.Tclcdata['CertType'] === 'RET' || this.Tclcdata['CertType'] === 'LANG' || this.Tclcdata['CertType'] === 'ATTFE' || this.Tclcdata['CertType'] === 'VOD') {   
        this.getTclcDocs(this.Tclcdata['StuId']);
        this.SaveDisabled = true;
        return;
      }
      this.UploadedDocs();
      this.getTclcDocs(this.Tclcdata['StuId']);
      this.GetTranscript(this.Tclcdata['StuId']);
      if (this.Tclcdata['CertStatus'] == 'UFD' && this.Tclcdata['CertType'] == 'TS') {
        this.SaveDisabled = true;
      } else {
        this.SaveDisabled = false;
      }
      this.CertScrutinyForm = new FormGroup({
        Comment: new FormControl(''),
        CertStatus: new FormControl('UFD', Validators.required),
      });
    });
  }

  loadsettingspage(CertType) {
    let FormName = '';
    if (CertType == 'TS') {
      FormName = 'TranscriptScrutiny';
    }
    else if (CertType == 'ADMC') {
      FormName = 'AdmCancelScrutiny';
    }
    else if (CertType == 'TC') {
      FormName = 'TransferScrutiny';
    }
    else if (CertType == 'LC') {
      FormName = 'LeavingScrutiny';
    }
    else if (CertType == 'MC') {
      FormName = 'MigrationScrutiny';
    }
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = FormName;
    // payload['Inst'] = sessionStorage.getItem('Inst');
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      this.ScrutinyFormArray = res.data.reduce((result, item) => {
        result[item.FormControlName] = result[item.FormControlName] || [];
        result[item.FormControlName].push(item);
        return result;
      }, {});
      this.ScrutinyData = true;
      this.initialize()

    });
  }
  // enable() {
  //   this.BranchDisabled = false;
  // }

  AdmFees() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.getFeeTempData(res.data[0].SessionId, res.data[0].StuCoId, res.data[0].StuCgId, res.data[0].StuId)
      }
    })
  }

  ExamData() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {

      if (res.status) {
        if (res.data.length > 0) {
          this.getRegData(res.data[0])
        }
      }
    })
  }

  UploadedDocs() {
    this.isLoadingUploadedDocs = true;
    this.spinner.show()
    let payload = {};
    payload['SessionId'] = this.Tclcdata['SnNo'],
    payload['StuId'] = this.Tclcdata['StuId'],
    payload['Emid'] = this.Tclcdata['Emid'],
    payload['StuSubId'] = 0,
    payload['TclcId'] = this.Tclcdata['TclcId'] || 0
    this.umsService.GetTcLcDocUploadDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.AdminUpload = res.data
        if (this.Tclcdata['CertStatus'] == 'UFD' && this.Tclcdata['CertType'] == 'TS') {
          this.DocUploaded = true;
          this.SaveDisabled = false;
        }

        }
        else {
          this.spinner.hide()
          this.DocUploaded = false;
          this.SaveDisabled = false;
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        this.DocUploaded = false;
        this.SaveDisabled = false;
      })
  }

  // Print() {

  //   var filter: any;
  //   let payload1 = {}
  //   payload1['StuId'] = this.StudentId;
  //   let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
  //   var filter: any;
  //   if (this.TranscriptData[0].StuCourse == 'BAMS-2010') {
  //     this.reptCourse = 'B2010'
  //   } else if (this.TranscriptData[0].StuCourse == 'BAMS-2012') {
  //     this.reptCourse = 'B2012'
  //   }
  //   else if (this.TranscriptData[0].StuCourse == 'BAMS-2017') {
  //     this.reptCourse = 'B2017'
  //   } else {
  //     this.reptCourse = this.TranscriptData[0].StuCourse;
  //   }
  //   console.log("this.TranscriptData[0].StuCourse", this.TranscriptData[0].StuCourse);
  //   filter = {
  //     "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
  //     "RptCode": 301,
  //     "InstName": '',
  //     "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
  //     "ShId": '',
  //     "CgCode": '',
  //     "RollNo": '',
  //     "Cent": '',
  //     "TnCode": '',
  //     "EsId": '',//this.emid
  //     "CsNo": '',
  //     "PgBreak": '',
  //     "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
  //     "StrCode": '',
  //     "RgNo": '',
  //     "UC": '',
  //     "Ledger": '',
  //     "RegnRoll": '',
  //     "DsCode": '',
  //     "CoCode": this.reptCourse, //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
  //     "SnNo": this.Tclcdata['SnNo'],
  //     "Extra1": JSON.stringify(payload1),
  //   }
  //   var payload: any;
  //   payload = filter;
  //   this.umsService.setData(JSON.stringify(payload));
  //   this.redirect('reports')
  // }
  Print() {

    var filter: any;
    let payload1 = {}
    payload1['StuId'] = this.StudentId;
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
    var filter: any;
      this.reptCourse = this.TranscriptData[0].StuCourse;
    
    console.log("this.TranscriptData[0].StuCourse", this.TranscriptData[0].StuCourse);
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 303,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": this.reptCourse,
      "SnNo": this.Tclcdata['SnNo'],
      "Extra1": JSON.stringify(payload1),
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('hbsreports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  FetchApplyUni(CdCode) {
    const payload = {};
    payload['CdType'] = 'APUN';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        res.data.forEach(element => {
          if (element.CdCode == CdCode) {
            this.wesDesc = element.CdDesc;
          }
        });

      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  GetFinalReport() {
    this.showbase643(this.AdminUpload[0].FileUpload)
  }
}